import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../api-service/api-service';
import { API } from '../../API';

export type LicenceEntityTypeApi = 'player' | 'manager' | 'staff' | 'referee' | 'club';

@Injectable({ providedIn: 'root' })
export class LicenceService {
  constructor(private api: ApiService) {}

  generate(demandeId: number, entityType: LicenceEntityTypeApi): Observable<any> {
    return this.api.post(API.LICENCES.GENERATE, { demande_id: demandeId, entity_type: entityType });
  }

  generateAll(entityType: LicenceEntityTypeApi): Observable<{ success: boolean; total: number; generated: number; failed: number; errors: any[] }> {
    return this.api.post(API.LICENCES.GENERATE_ALL, { entity_type: entityType });
  }
}
